import styled from 'styled-components';
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from 'recharts';

const LineData = [
  { name: '매각율', color: 'rgba(250, 129, 47, 1)' },
  { name: '매각가율', color: 'rgba(0, 138, 255, 1)' },
  { name: '매각기대율', color: 'rgba(250, 64, 50, 1)' },
];

const Charts = ({ chartData }: any) => {
  // const CustomLegend = () => (
  //   <div
  //     style={{
  //       position: 'absolute',
  //       right: 0,
  //       bottom: 90,
  //       padding: '5px',
  //     }}
  //   >
  //     {LineData.map((el, i) => (
  //       <div
  //         key={i}
  //         style={{
  //           display: 'flex',
  //           flexDirection: 'row',
  //           alignItems: 'center',
  //           gap: '4px',
  //         }}
  //       >
  //         <div
  //           style={{
  //             width: '12px',
  //             height: '2px',
  //             background: el.color,
  //           }}
  //         />
  //         <div style={{ color: el.color }}> {el.name}</div>
  //       </div>
  //     ))}
  //   </div>
  // );

  const CustomLegend = (props: any) => {
    const { payload } = props;
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '16px',
          marginTop: '10px',
        }}
      >
        {payload.map((entry: any, index: number) => (
          <div
            key={`legend-${index}`}
            style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
          >
            {/* 🔹 동그라미 아이콘 */}
            <div
              style={{
                width: '6px',
                height: '6px',
                backgroundColor: entry.color,
                borderRadius: '50%',
              }}
            />
            <span style={{ fontSize: '12px', color: '#333' }}>
              {entry.value}
            </span>
          </div>
        ))}
      </div>
    );
  };

  // 동적으로 ticks 생성
  // y축 값 설정
  const generateTicks = (data: any) => {
    if (data.length === 0) return [0, 25, 50, 75, 100];
    // data의 salepricerate 중 최대값을 찾아서 ticks에 추가
    // 첫번째 값이 가장 큰 값이라고 가정
    const maxValue = data[0].salerricerate;
    let ticks = [0, 25, 50, 75, 100];

    if (maxValue > 100) ticks.push(125);
    if (maxValue > 125) ticks.push(150);
    if (maxValue > 150) ticks.push(200);
    return ticks;
  };

  const ticks = generateTicks(chartData);
  return (
    <AnalysisInfoContainer>
      <AnalysisDataBox>
        <GraphBox>
          <GraphDataBox>
            <ResponsiveContainer width="100%" height={205}>
              <LineChart data={chartData}>
                <XAxis
                  dataKey="auctionround"
                  scale="point"
                  tick={{
                    color: 'rgba(23,30,38,0.56)',
                    fontSize: 11,
                    fontFamily: 'Pretendard-Medium',
                  }}
                  tickLine={false}
                  axisLine={false} // X축 선을 제거
                  interval={0}
                />
                {/* <YAxis width={30} /> */}
                <YAxis
                  width={30}
                  axisLine={false} // Y축 선을 제거
                  tick={{
                    color: 'rgba(23,30,38,0.56)',
                    fontSize: 11,
                    fontFamily: 'Pretendard-Medium',
                    fontWeight: '400',
                  }}
                  tickLine={false}
                  ticks={ticks} // 동적 ticks 설정
                  domain={[0, Math.max(...ticks)]} // Y축 범위를 ticks에 맞추기
                  tickFormatter={(value) => (value === 0 ? 0 + '(%)' : value)}
                />
                <Legend content={<CustomLegend />} />{' '}
                <Line
                  type="monotone"
                  dataKey="salerricerate"
                  stroke="rgba(0, 138, 255, 1)"
                  fillOpacity={1}
                  fill="url(#colorPv)"
                  name="매각가율"
                  strokeWidth={2}
                  dot={false}
                />
                <Line
                  type="monotone"
                  dataKey="expectedsalepricerate"
                  stroke="rgba(250, 64, 50, 1)"
                  fillOpacity={1}
                  fill="url(#colorPv)"
                  name="매각기대율"
                  strokeWidth={2}
                  dot={false}
                />
                <Line
                  type="monotone"
                  dataKey="salerate"
                  stroke="rgba(250, 129, 47, 1)"
                  fillOpacity={1}
                  fill="url(#colorPv)"
                  name="매각율"
                  strokeWidth={2}
                  dot={false}
                />
                <CartesianGrid
                  stroke="#ccc"
                  strokeWidth={1}
                  vertical={false}
                  horizontal={true}
                />
              </LineChart>
            </ResponsiveContainer>
          </GraphDataBox>
        </GraphBox>
      </AnalysisDataBox>
    </AnalysisInfoContainer>
  );
};

export default Charts;

const AnalysisInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  width: 100%;
  //   height: 579px;
`;

const AnalysisDataBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

const GraphBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  height: 205px;
  justify-content: space-between;
`;

const GraphDataBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  width: 100%;
  justify-content: center;
`;
